export const messages = {
    "wr-dashboard.search.input.hint": "Søk",
    "wr-dashboard.search.label.breadcrumb": "Søkeresultater",
    "wr-dashboard.search.message.empty": "Ingen elementer stemmer overens med søket ditt",
    "wr-dashboard.side-bar.selected.title:plural": "{count} elementer er valgt | {count} element er valgt | {count} elementer er valgt",
    "wr-dashboard.side-bar.backup-type.disk": "Disk",
    "wr-dashboard.side-bar.backup-type.file": "Fil",
    "wr-dashboard.side-bar.backup-type.notarized": "Attesterte filer og foldere",
    "wr-dashboard.side-bar.backup-type.exchange": "Applikasjon – Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Applikasjon – Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Applikasjon – Systemtilstand",
    "wr-dashboard.side-bar.backup-type.application": "Applikasjon",
    "wr-dashboard.backups-table.column.name": "Navn",
    "wr-dashboard.backups-table.column.size": "Størrelse",
    "wr-dashboard.backups-table.column.version": "Siste versjon",
    "wr-dashboard.backups-table.action.delete": "Slett",
    "wr-dashboard.backups-table.message.no-backups": "Det finnes foreløpig ingen sikkerhetskopier i Cloud",
    "wr-dashboard.backups-sidebar.label.size": "Størrelse",
    "wr-dashboard.backups-sidebar.label.type": "Type",
    "wr-dashboard.backups-sidebar.label.version": "Siste versjon",
    "wr-dashboard.backups-sidebar.label.created": "Opprettet",
    "wr-dashboard.backups-sidebar.label.machine": "Maskin",
    "wr-dashboard.backups-sidebar.label.owner": "Eier",
    "wr-dashboard.content-table.column.name": "Navn",
    "wr-dashboard.content-table.column.versions": "Versjoner",
    "wr-dashboard.content-table.column.volumes": "Volumer",
    "wr-dashboard.content-table.column.path": "Bane",
    "wr-dashboard.content-table.column.size": "Størrelse",
    "wr-dashboard.content-table.column.version": "Siste versjon",
    "wr-dashboard.content-table.action.notary-verify": "Verifiser",
    "wr-dashboard.content-table.action.notary-get-crt": "Hent sertifikat",
    "wr-dashboard.content-table.action.asign": "Send for signatur",
    "wr-dashboard.content-table.action.versions": "Versjoner",
    "wr-dashboard.content-table.action.restore": "Last ned",
    "wr-dashboard.content-table.label.size": "Størrelse",
    "wr-dashboard.content-table.label.created": "Opprettet",
    "wr-dashboard.content-table.label.modified": "Endret",
    "wr-dashboard.content-table.message.empty-folder": "Denne mappen er tom",
    "wr-dashboard.password-dialog-box.title.backup": "Kryptert sikkerhetskopi",
    "wr-dashboard.password-dialog-box.title.archive": "Kryptert arkiv",
    "wr-dashboard.password-dialog-box.message.backup": "Spesifiser passordet for å få tilgang til sikkerhetskopien {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Spesifiser passordet for å få tilgang til arkivet {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Passord",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Passordet er feil",
    "wr-dashboard.form.button.open": "Åpne",
    "wr-dashboard.form.button.close": "Lukk",
    "wr-dashboard.form.button.cancel": "Avbryt",
    "wr-dashboard.form.button.continue": "Forsett",
    "wr-dashboard.form.button.proceed": "Fortsett",
    "wr-dashboard.form.button.delete": "Slett",
    "wr-dashboard.form.button.done": "Ferdig",
    "wr-dashboard.form.button.retry": "Prøv på nytt",
    "wr-dashboard.notary.verify.view.status.downloading": "Laster ned …",
    "wr-dashboard.notary.verify.view.status.validating": "Validerer...",
    "wr-dashboard.notary.verify.view.status.pending": "Sertifikat venter...",
    "wr-dashboard.notary.verify.view.status.fail": "Sertifikat samsvarer ikke...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Hent sertifikat",
    "wr-dashboard.notary.verify.view.file-info.name": "NAVN",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "SIGNERT AV",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATO SIKKERHETSKOPIERT",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATO ATTESTERT",
    "wr-dashboard.notary.verify.view.button.cancel": "Avbryt",
    "wr-dashboard.notary.verify.view.button.done": "Ferdig",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Nettleserversjonen støttes ikke",
    "wr-dashboard.versions-dialog-box.title": "Versjoner av {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Send for signatur",
    "wr-dashboard.asign-dialog-box.message": "Filversjonen er delt, men ingen kan se filen uten koblingen til den. Fortsett til ASign for å legge til signaturer og dele koblingen.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Vis fildetaljer",
    "wr-dashboard.page-not-found.title": "Fant ikke siden",
    "wr-dashboard.page-not-found.message.main": "Fant ikke siden du så etter.",
    "wr-dashboard.page-not-found.message.description": "Koblingen kan være utdatert, eller du kan ha skrevet inn feil adresse.",
    "wr-dashboard.page-not-found.message.error": "Feilkode: 404",
    "wr-dashboard.server-error.title": "Serveren er ikke tilgjengelig",
    "wr-dashboard.server-error.message": "Serveren er for øyeblikket ikke tilgjengelig. Prøv på nytt senere.",
    "wr-dashboard.server-error.message.error": "Feilkode: 500",
    "wr-dashboard.account-menu.action.sign-out": "Logg av",
    "wr-dashboard.breadcrumb.item.machines": "Maskiner",
    "wr-dashboard.breadcrumb.item.failed-backups": "Mislykkede sikkerhetskopier",
    "wr-dashboard.machines-table.column.name": "Navn",
    "wr-dashboard.machines-table.column.size": "Størrelse",
    "wr-dashboard.machines-table.message.no-machines": "Det finnes foreløpig ingen maskiner i skyen",
    "wr-dashboard.incomplete-backups.message.status:plural": "Du har {count} mislykkede eller ufullstendige sikkerhetskopier som okkuperer {size} av lagring | Du har {count} mislykket eller ufullstendig sikkerhetskopi som okkuperer {size} med lagring | Du har {count} mislykkede eller ufullstendige sikkerhetskopier som okkuperer {size} av lagring",
    "wr-dashboard.incomplete-backups.button.view": "Vis sikkerhetskopier",
    "wr-dashboard.incomplete-backups.button.delete": "Slett sikkerhetskopier",
    "wr-dashboard.machines-table.message.space-used:plural": "Total sikkerhetskopibruk {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Slett arkiver",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Slett ufullstendige arkiver",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Slett alle ufullstendige arkiver",
    "wr-dashboard.delete-archive.message": "Er du sikker på at du vil slette de valgte arkivene permanent fra alle plasseringer? Alle data slettes og kan ikke tilbakestilles.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Sertifikat venter",
    "wr-dashboard.certificate-pending-dialog-box.message": "Prøv på nytt om noen minutter.",
    "wr-dashboard.form.button.ok": "OK"
};
